<template>
  <div class='reportList'>
    <el-row class='reportList-nav' id='reportListnav'>
      <el-col >
        <el-form :inline="true" label-width="80px" :model="search" ref="search" size='mini' class="demo-form-inline">
          <el-row>
            <el-col>
              <el-form-item label="设备类型">
                <el-radio-group v-model="search.modality" @change='onSubmit(1)'>
                  <el-radio-button  label='' >全部</el-radio-button>
                  <el-radio-button  v-for='item in checkList.checkType' :key='item.name' :label='item.name' >{{item.name}}</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="影像室">
                <el-radio-group v-model="search.examinRoom" @change='onSubmit(1)'>
                  <el-radio-button  label=''>全部</el-radio-button>
                  <el-radio-button  v-for='item in imageRoom' :key='item.examRoom' :label='item.examRoom' v-if='item.examRoom'></el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="医疗状态">
                <el-radio-group v-model="search.status" @change='onSubmit(1)'>
                  <el-radio-button  label='0' >全部</el-radio-button>
                  <el-radio-button  v-for='item in medicalStatus' :key='item.status' :label='item.statusName' :value='item.status'>{{item.statusName}}</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item style='width:7%;min-width: 60px;'>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit(1)">查询</el-button>
              </el-form-item>
              <el-form-item  style='width:7%;min-width: 60px;'>
                <el-button type="success" icon="el-icon-circle-close-outline" @click="resetForm">清空</el-button>
              </el-form-item> -->
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
     <div class="reportList-table" >
        <el-table v-if='PerformList.length > 0' stripe :data='PerformList' :span-method="objectSpanMethod" size='mini' v-loading="tableloading"  style='width: 100%'>
            <!-- <el-table-column prop='modality' label='设备类型' min-width='120px'>
              <template slot-scope="scope">
                <div class="name-wrapper">
                  <span style='background:#FF8C8C;' v-if='scope.row.modality'>{{ scope.row.modality }}</span>
                  <div v-else></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop='bodyPart' label='检查部位' min-width='120px'>
              <template slot-scope="scope">
                <div class="name-wrapper">
                  <span style='background:#49C1E4;' v-if='scope.row.bodyPart'>{{ scope.row.bodyPart }}</span>
                  <div v-else></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop='checkingItem' label='检查项目' width='180px' >
               <template slot-scope="scope">
                 <el-popover trigger="hover" placement="top">
                    {{ scope.row.checkingItem }}
                  <div slot="reference" class="name-wrapper">
                    <span v-if='scope.row.checkingItem'>{{ scope.row.checkingItem | checkingItem}}</span>
                    <div v-else></div>
                  </div>
                </el-popover>
               </template>
            </el-table-column> -->
            <el-table-column :fixed="index === 0" v-for='(col, index) in headerList'  v-if='col.isShow' :show-overflow-tooltip = 'true' :key='index'  :min-width="col.width" :prop='col.prop' :label='col.label' >
              <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top" v-if="col.prop === 'checkingItem'">
                      {{ scope.row[col.prop] | checkingItems}}
                      <div slot="reference" class="name-wrapper">
                        <span style="background: #ff9d60;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop] | checkingItems}}</span>
                        <div v-else></div>
                      </div>
                    </el-popover>
                    <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'modality'">
                      {{ scope.row[col.prop]}}
                      <div slot="reference" class="name-wrapper">
                        <span style="background: #FF8C8C;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop]}}</span>
                        <div v-else></div>
                      </div>
                    </el-popover>
                    <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'bodyPart'">
                      {{ scope.row[col.prop]}}
                      <div slot="reference" class="name-wrapper">
                        <span style="background: #49C1E4;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop]}}</span>
                        <div v-else></div>
                      </div>
                    </el-popover>
                    <span v-else>
                      {{scope.row[col.prop]}}
                    </span>
                  </template>
            </el-table-column>
            <!-- <el-table-column prop='patientName' label='姓名' width='100px'> </el-table-column>
            <el-table-column prop='gender' label='性别' width='80px'> </el-table-column>
            <el-table-column prop='age' label='年龄' width='80px'> </el-table-column>
            <el-table-column prop='statusName' label='医疗状态' width='110px'></el-table-column>
            <el-table-column prop='examinRoom' label='影像室' width='110px'></el-table-column>
            <el-table-column prop='performNo' label='检查号' width='180px'></el-table-column>

            <el-table-column prop='scanMode' label='扫描类型' width='110px'>
              <template slot-scope="scope">
                  <span  v-if='scope.row.scanMode'>{{ scope.row.scanMode }}</span>
              </template>
            </el-table-column>
            <el-table-column prop='register' label='登记医生' width='110px'> </el-table-column>
            <el-table-column prop='regDt' label='登记时间' min-width='180px'> </el-table-column> -->
            <el-table-column prop='' label='功能' width='100px' size='mini' fixed="right">
              <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="开始检查" placement="top" >
                    <el-button v-if='scope.row.status < 20' style="background:#44cc79;color:#fff;border:none;float:left;margin-right:10px;" type="" size='mini' circle @click='dbTalble(scope.row)'><svg-icon style="padding-left: 3px;"  icon-class='start-check'></svg-icon></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="关联影像" placement="top" >
                    <el-button style="background:#5ab1ef;color:#fff;border:none;" type="" size='mini' circle @click='openUpdateImg(scope.row);getImagelist()' ><svg-icon  icon-class='relevance'></svg-icon></el-button>
                  </el-tooltip>
              </template>
            </el-table-column>
        </el-table>
        <el-row style="text-align: center;" v-if="PerformList.length > 0">
          <div class="block">
            <el-pagination
              @current-change="handlePageCurrentChange"
              @size-change="handleSizeChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 40, 80, 100]"
              :page-size="search.PageCount"
              layout="total, sizes, prev, pager, next, jumper"
              :total="PerformListtotalCount"
            ></el-pagination>
          </div>
         </el-row>
        <div v-else style="width:100%;height: calc(100vh - 261px);text-align:center;background:#f8f8f8;" v-loading="tableloading">
          <img src="../../assets/empty_01.png" alt="" style="width: auto;height: calc(100vh - 357px);"  />
        </div>
    </div>
    <el-dialog title="关联影像" :visible.sync="dialogTableVisible" width="80%"  custom-class='revisitDialog' ref="dialog" @close = 'close'>
      <el-row :gutter='20'>
        <el-col :span="3">
            <el-input v-model='patientName' size="mini" type="text" placeholder='患者姓名' ></el-input>
        </el-col>
        <el-col :span="3">
            <el-input v-model='patientId' size="mini" type="text" placeholder='患者ID' ></el-input>
        </el-col>
        <el-col :span="3">
            <el-select v-model="studyState" size="mini" placeholder="影像状态">
                <el-option label="全部" value=0>全部</el-option>
                <el-option label="上传中" value=2>上传中</el-option>
                <el-option label="已上传" value=4>已上传</el-option>
              </el-select>
        </el-col>

        <el-col :span="3">
          <el-select v-model="select_check_type" size="mini" placeholder="设备类型" clearable>
                <el-option v-for="item in checkList.checkType" :key="item.id"  :label="item.name" :value="item.id">
                </el-option>
          </el-select>
        </el-col>
        <el-col :span='3'>
            <el-select v-model="timeType" size="mini"  placeholder="时间类型">
                <el-option label='归档时间' value='1'></el-option>
                <el-option label='检查时间' value='2'></el-option>
            </el-select>
        </el-col>
        <el-col :span="7">
            <el-date-picker style="width:100%" v-model="select_time"  type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                value-format="yyyy-MM-dd"  size="mini">
            </el-date-picker>
        </el-col>
        <el-col :span="2">
            <el-button type='primary' size="mini" @click="getImagelist" >查询</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top:20px;border-top:1px solid #397EE3;">
        <el-table :data="table" stripe max-height='300px' size='mini' height="300" highlight-current-row @current-change="handleCurrentChange" v-loading = 'imgListloading'>
          <el-table-column property="patientName" label="姓名" width="120"></el-table-column>
          <el-table-column property="patientId" label="患者ID" width="180"></el-table-column>
          <el-table-column property="patientSex" label="性别">
            <template slot-scope="scope">
                <span>{{ scope.row.patientSex | changeSex }}</span>
            </template>
          </el-table-column>
          <el-table-column property="modalities[0]" label="设备类型"></el-table-column>
          <el-table-column property="studyState" label="影像状态">
              <template slot-scope="scope">
                <span>{{ scope.row.studyState | studyStates }}</span>
            </template>
          </el-table-column>

          <el-table-column property="studyDt" label="检查时间" width="180"></el-table-column>
          <el-table-column property="createDt" label="归档时间" width="180"></el-table-column>
        </el-table>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini' style="" @click="fillInfor(fillInfors)"> 确 定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/index.js'
export default {
  name: 'Screening',
  data() {
    return {
      tableloading: false,
      imgListloading: false,
      dialogTableVisible: false,
      select_time: [
        formatDate(new Date(), 'yyyy-MM-dd'),
        formatDate(new Date(), 'yyyy-MM-dd')
      ],
      fillInfors: '',
      select_check_type: '',
      patientName: '',
      patientId: '',
      studyState: '0',
      timeType: '1',
      search: {
        status: 0,
        departId: '',
        examinRoom: '',
        modality: '',
        PageCount: 10,
        PageIndex: 1
      },
      ReportList: [],
      navHeight: 102,
      Update: {
        performId: '',
        performNo: '',
        studyUid: '',
        status: 20
      },
      table: [],
      currentPage: 1,
    }
  },
  beforeMount() {
  },
  mounted() {

  },
  created() {
    this.getChecktype()
    this.getimageRoom()
    this.getStatusList()
    this.onSubmit()
    this.GetTableHeaderConfigs()
  },
  computed: {
    ...mapGetters([
      'dict',
      'userId',
      'checkList',
      'currentUserRoleDepart',
      'imageRoom',
      'PerformList',
      'PerformListtotalCount',
      'medicalStatus',
      'imgList',
      'departId',
      'headerList'
    ]),
    newModality() {
      return this.search.modality
    }
  },
  methods: {
    getImagelist(value) {
      this.imgListloading = true
      this.$store.dispatch('getImageList', {
        startDate: this.select_time[0],
        endDate: this.select_time[1],
        departId: this.departId,
        deviceTypeId: this.select_check_type,
        patientId: this.patientId,
        patientName: this.patientName,
        studyState: this.studyState,
        dateType: '1'
      }).then(() => {
        this.imgListloading = false
        this.table = []
        var temp = []
        if (this.imgList.length > 0) {
          for (let index1 = 0; index1 < this.imgList.length; index1++) {
            const data = this.imgList[index1]
            for (let index2 = 0; index2 < data.mImagetList.length; index2++) {
              temp.push(data.mImagetList[index2])
            }
          }
          this.table = temp
        }
      }).catch(() => { this.imgListloading = false })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 12) {
        if (row.siblingsCount) {
          return {
            rowspan: row.siblingsCount,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    handleSizeChange(val) {
      this.search.PageCount = val
      this.onSubmit(1)
    },
    handlePageCurrentChange(val) {
      this.onSubmit(val)
    },
    handleCurrentChange(row) {
      this.fillInfors = row
    },
    fillInfor(row) {
      if (row.studyState > 3) {
        this.Update.studyUid = row.studyUid
        this.UpdateImg()
        this.dialogTableVisible = false
      } else {
        this.$message({ message: '状态为已上传时才可选择影像！', type: 'warning' })
      }
    },
    GetTableHeaderConfigs() {
      this.$store.dispatch('GetTableHeaderConfigs', { departId: this.currentUserRoleDepart.departId, type: 2 }).then(() => { //
      }).catch(() => {
        this.$message({ message: '获取表头配置失败，请重新获取', type: 'warning' })
      })
    },
    getimageRoom(value) {
      if (value) {
        var temp = ''
        for (let i = 0; i < this.checkList.checkType.length; i++) {
          if (this.checkList.checkType[i].name === value) {
            temp = this.checkList.checkType[i].id
            break
          }
        }
        this.$store.dispatch('getimageRoom', { departId: this.currentUserRoleDepart.departId, deviceType: temp }).then(() => { // 影像室
        }).catch(() => {
          this.$message({ message: '获取影像室失败，请重新获取', type: 'error' })
        })
      } else {
        this.$store.dispatch('getimageRoom', { departId: this.currentUserRoleDepart.departId, deviceType: null }).then(() => { // 影像室
        }).catch(() => {
          this.$message({ message: '获取影像室失败，请重新获取', type: 'error' })
        })
      }
    },
    getChecktype() {
      this.$store.dispatch('getcheckType', { departId: this.currentUserRoleDepart.departId }).then(() => { // 设备类型

      }).catch(() => {
        this.$message({ message: '获取设备类型失败，请重新获取', type: 'error' })
      })
    },
    onSubmit(val) {
      this.search.PageIndex = val || 1
      this.tableloading = true
      this.$store
        .dispatch('getPerformList', this.search)
        .then(() => {
          this.loading = false
          this.tableloading = false
        })
        .catch(() => {
          this.loading = false
          this.tableloading = false
        })
    },
    getStatusList() {
      this.$store
        .dispatch('getStatusList')
        .then(() => {
        })
        .catch(() => {
        })
    },
    resetForm() {
      this.$refs['search'].resetFields()
      this.search.Modality = ''
      this.search.bodyPart = ''
    },
    dbTalble: function(row) {
      this.Update = {
        performId: row.performId,
        performNo: row.performNo,
        studyUid: row.studyUID,
        status: 20
      }
      this.$store
        .dispatch('beginExamination', this.Update)
        .then(() => {
          this.onSubmit()
          this.$message({ message: '成功开始检查！', type: 'success' })
        })
        .catch(() => {
          this.$message({ message: '开始检查失败，请重试！', type: 'error' })
        })
    },
    UpdateImg() {
      this.$store.dispatch('updateProcedureStatus', this.Update)
        .then(() => {
          this.dialogTableVisible = false
          this.onSubmit()
          this.$message({ message: '成功关联影像！', type: 'success' })
        })
        .catch(() => {
          this.$message({ message: '关联影像失败，请重试！', type: 'error' })
        })
    },
    openUpdateImg: function(row) {
      this.Update = {
        performId: row.performId,
        performNo: row.performNo,
        studyUid: row.studyUID,
        status: 40
      }
      this.dialogTableVisible = true
    },
    close() {
      this.table = []
      // this.select_check_type = this.checkList.checkType[0].id
      this.select_time = [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
    }
  },
  watch: {
    $route() {
      this.$store.dispatch('resetdiagnostic')
    },
    newModality(val) {
      this.search.examinRoom = ''
      this.getimageRoom(val)
    },
    dialogTableVisible(val) {
      // if (val) {
      //   this.$store
      //     .dispatch('getImageList')
      //     .then(() => {
      //     })
      //     .catch(() => {
      //     })
      // }
    }
  },
  filters: {
    checkingItems(datas) {
      if (datas) {
        if (datas.length > 11) {
          datas = datas.slice(0, 10) + '…'
        }
        return datas
      } else {
        return ''
      }
    },
    changeSex(data) {
      if (data === 'M') {
        return '男'
      } else {
        return '女'
      }
    },
    studyStates(data) {
      if (data === 0) {
        return '未定义'
      } else if (data === 1) {
        return '待上传'
      } else if (data === 2) {
        return '上传中'
      } else if (data === 3) {
        return '上传中'
      } else if (data > 3) {
        return '已上传'
      }
    }
  }

}

</script>
<style rel='stylesheet/scss' lang='scss' scoped>
  .reportList{
    height: 100%;
    overflow-y: auto;
    .el-tabs{
      padding: 0px 20px;
      margin-top: 20px;
    }
    .reportList-nav{
      height: auto;
      background: #f8f8f8;
      margin:20px;
      padding: 10px;
      padding-bottom: 0px;
      .el-form-item{
        margin-bottom: 10px;
      }
      // .el-checkbox-button, .el-checkbox-button__inner{
      //   margin-right: 10px;
      // }

    }
    .reportList-table{
      border-top: 2px solid #dddddd;
      background: #f3f5f9;
      margin:20px;
    }
    .hamburger {
      transform: rotate(90deg);
      transition: .38s;
      transform-origin: 50% 50%;
    }
    .hamburger.is-active {
      transform: rotate(270deg);
    }
    .toggleSearch{
      height: 0px;
      -webkit-transition: height .28s;
      transition: height .28s;
      overflow: hidden;
    }
    .toggleSearchType .toggleSearch{
      height: 110px;
      -webkit-transition: height .28s;
      transition: height .28s;
      overflow: hidden;
    }
    .name-wrapper{
      height: 23px;
      span{
        background: #FF9D60;
        color:#fff;
        padding: 4px 5px;
        border-radius: 3px;
        // width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .nav-top{
      .el-form-item{
        width: 12.5%;
      }
    }
  }
</style>
